import React, { useImperativeHandle } from 'react';
import ReactDatePicker from 'react-datepicker';
import '../sharedFormControl.css'
import smCalendarIcon from '../../../../../../assets/images/Icons/sm-calendar-icon.svg'
import { Image } from 'react-bootstrap';

const CustomisedDatePicker = (props, ref) => {

    const userDetails = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

    useImperativeHandle(ref, () => ({ isValid }), [props.value]);

    const isValid = () => {

        if (props.required && props.value)
            return true;
        else if (props.required && !props.value)
            return false;

        return true;

    }

    const onChange = (val) => {

        if (props.onChange)
            props.onChange(props.objectKey, val);

    }

    return (
        <React.Fragment>
            <div className='default-date-picker'>
                <fieldset className={`default-fieldset ${props.zeroMargin ? 'mb-0' : ''} ${props.disabled ? 'disabled-form-field' : ''}`}>
                    {!props.hideLegend ?
                        <>
                            <legend className='default-fieldset-label'>{props.label ? props.label : ''}</legend>
                            <span>{!props.documentUrl ? '' : ''}</span>
                        </> :
                        null}
                    <ReactDatePicker
                        required={props.required}
                        // dateFormat="MM/dd/y"
                        popperPlacement={props.autoPlacement ? props.autoPlacement : "auto"}
                        placeholderText="MM/DD/YYYY"
                        isClearable={props.hideClearable || userDetails?.readOnlyAccess ? false : true}
                        showYearDropdown
                        showMonthYearPicker={props.showMonthYearPicker ? true : false}
                        autoComplete='off'
                        selected={props.value ? props.value : null}
                        onChange={(date) => onChange(date)}
                        disabled={props.disabled ? props.disabled : ''}
                        excludeDates={props.excludeDates ? props.excludeDates : ''}
                        filterDate={props.filterDate ? props.filterDate : ''}
                        minDate={props.minDate ? props.minDate : ''}
                        maxDate={props?.maxDate}
                        popperProps={{
                            positionFixed: true
                        }}
                        popperConfig={{ strategy: 'fixed' }}
                        popperModifiers={{ flip: { behavior: ["auto"] }, preventOverflow: { enabled: false }, hide: { enabled: false } }}
                        customInput={props.customInput ? props.customInput : ''}
                        dateFormat={props.dateFormat ? props.dateFormat : ''}
                    // placeholderText={props.placeholder ? props.placeholder : ''}
                    />
                    <Image className='calendar-icon' src={smCalendarIcon} alt='icon' fluid />
                </fieldset>
                {props.required && props.validated && !isValid() ? <span className='invalid-feedback'>{props.errorMessage ? props.errorMessage : `Please select a ${props.name}.`}</span> : null}
            </div>
        </React.Fragment>
    )

}

export default React.forwardRef(CustomisedDatePicker);